import { useRef, useLayoutEffect } from 'react';

type Effect = ({ scrollY }: { scrollY?: number }) => void;
type EffectOptions = { wait?: number; isHeightWatcher?: boolean };

const useScroll = (effect: Effect, options?: EffectOptions, dep: any[] = []) => {
  const bodySize = useRef(document.body.getBoundingClientRect());

  let throttleTimeout = false;

  const callBack = () => {
    const newBodySize = document.body.getBoundingClientRect();
    const positionChanged = bodySize.current.y !== newBodySize.y;

    if (positionChanged) {
      if (options?.isHeightWatcher) {
        if (bodySize.current.height !== newBodySize.height) {
          effect({});
        }
      } else {
        effect({ scrollY: newBodySize.y });
      }
      bodySize.current = newBodySize;
    }
    throttleTimeout = false;
  };

  useLayoutEffect(() => {
    callBack();
    const handleScroll = () => {
      if (options?.wait) {
        if (!throttleTimeout) {
          throttleTimeout = true;
          setTimeout(callBack, options.wait);
        }
      } else {
        callBack();
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => window.removeEventListener('scroll', handleScroll);
  }, dep);
};

export default useScroll;
